/* ── Config shim: read JSON data island and set globals ── */
(function() {
    const el = document.getElementById('configurator-config');
    if (!el) return;
    const cfg = JSON.parse(el.textContent);

    window.Shopify = window.Shopify || {};
    Shopify.money_format = cfg.money_format || '{{amount}}';

    window.storefront_domain = '';
    window.storefront_access_token = cfg.storefront_access_token || '';
    window.ui_arrow_off = '';
    window.ui_arrow_on = '';
    window.options_translate = cfg.options_translate || {};
    window.default_configuration = (cfg.default_configuration || '').replace(/\s/g, '');
    window.page_variant_id = String(cfg.page_variant_id || '');
    window.page_product_title = cfg.page_product_title || '';
    window.init_configurators = cfg.init_configurators || [];

    var bc = cfg.bed_configuration || {};
    if (bc.available_sizes_raw && bc.available_sizes_raw !== '') {
        bc.sizes = bc.available_sizes_raw.replace(/[^0-9,x]+/g, '').split(',');
    } else {
        bc.sizes = bc.sizes || [];
    }
    if (bc.available_headboards_raw && bc.available_headboards_raw !== '') {
        bc.available_headboards = bc.available_headboards_raw.replace(/\s/g, '').split(',');
    } else {
        bc.available_headboards = bc.available_headboards || [];
    }
    if (bc.exclude_headboards_raw && bc.exclude_headboards_raw !== '') {
        bc.exclude_headboards = bc.exclude_headboards_raw.replace(/\s/g, '').split(',');
    } else {
        bc.exclude_headboards = bc.exclude_headboards || [];
    }
    // Headboard width overrides - for frames that are wider than the mattress (Hallsö),
    // the headboards must be wider too. Maps mattress width to headboard width per category:
    // "rivo:150=156,180=186; rivouk:150=156,180=186" -> { rivo: {150: 156, 180: 186}, ... }
    bc.headboard_width_map = bc.headboard_width_map || {};
    var widthMapRaw = bc.headboard_width_map_raw || '';
    if (widthMapRaw.trim() !== '') {
        widthMapRaw.replace(/\s/g, '').split(';').forEach(function(group) {
            var group_arr = group.split(':');
            if (group_arr.length != 2 || group_arr[0] === '' || group_arr[1] === '') { return; }

            var category = group_arr[0];
            bc.headboard_width_map[category] = {};

            group_arr[1].split(',').forEach(function(pair) {
                var pair_arr = pair.split('=');
                if (pair_arr.length != 2) { return; }
                bc.headboard_width_map[category][parseInt(pair_arr[0])] = parseInt(pair_arr[1]);
            });
        });
    }

    var excludedRaw = bc.excluded_skus_global || '';
    bc.excluded_skus_global_set = new Set(
        excludedRaw.trim() !== '' ? excludedRaw.replace(/\s/g, '').split(',').filter(function(s){return s !== '';}) : []
    );
    window.bed_configuration = bc;

    if (cfg.parent_and_options) {
        window.parent_and_options = cfg.parent_and_options;
    }
})();

class Configurator {
    constructor() {
        this.cache = {};
        this.selection = {};
        this.selector_objects = {};
        this.cart = [];
        this.bundle_id = null;
        this.enable_ecommerce = bed_configuration.enable_ecommerce == 1;

        this.features = {};
        this.cylindo_model = null;
        this.viewer = null;

        if (bed_configuration.product_split == '') {
            // Item page loaded - now load Parent product
            this.redirectToParentProduct();
        }

        document.addEventListener('DOMContentLoaded', () => {
            this.init();
        });
    }

    async redirectToParentProduct() {
        const parent_product = await this.loadProductData('configurator-reference', [{'key': 'productid', 'value': parent_and_options.parent}], [], true);

        for (const ref of parent_product) {
            if (parent_and_options.parent == ref.productid) {
                const params = [];

                if (parent_and_options.fabric != '') { params.push('fabric:'+parent_and_options.fabric); }
                if (parent_and_options.size != '') { params.push('size:'+parent_and_options.size); }
                if (parent_and_options.variant != '' && !parent_and_options.variant.includes('Default')) { params.push('firmness:'+parent_and_options.variant.toLowerCase()); }

                window.location.href = '/products/' + ref.handle + '/' + params.join(':');
            }
        }
    }

    async init() {
        console.log(`[CONFIG] init() — bed_configuration:`, JSON.stringify(bed_configuration));
        console.log(`[CONFIG] init() — init_configurators:`, JSON.stringify(init_configurators));

        this.viewer = document.querySelector("cylindo-viewer");

        // Reset bundle_id by default unless explicitly set by URL parameter
        this.bundle_id = null;

        // Load reference products
        const ref_products = await this.loadProductData('configurator-reference', [], ['productid'], true);
        configurator.reference = {};
        for (const ref of ref_products) {
            configurator.reference[ ref.productid ] = ref;
        }
        // Initialize Selector objects
        this.initSelectors();

        // Load config from URL or default configuration
        this.loadConfiguration();

        // Set up bed controls
        this.setupListeners();

        // Refresh selectors
        await this.refreshSelectors();

        // Update Cylindo player and price
        this.calculatePrice();
        this.updatePlayer();
    }

    initSelectors() {
        for (const selector of init_configurators) {
            const object_name = selector[0].toUpperCase() + selector.substring(1);

            console.log("Loading class Configurator"+object_name);
            const object = eval('new Configurator'+object_name+'()');

            this.selector_objects[selector] = object;
        }
    }

    async refreshSelectors(trigger) { // Accept trigger argument
        const promises = [];
        for (const selector in this.selector_objects) {
            // Pass the trigger argument to the individual refresh method
            promises.push( this.selector_objects[selector].refresh(trigger) );
        }
        await Promise.all(promises);
    }

    loadConfiguration() {
        console.log(`[CONFIG] loadConfiguration() — default_configuration: '${default_configuration}'`);
        const conf_params = default_configuration.split(':');
        console.log(`[CONFIG] conf_params: ${JSON.stringify(conf_params)}, length: ${conf_params.length}`);
        if (conf_params.length % 2 == 0) {
            for (let i = 0; i < conf_params.length; i += 2) {
                this.selection[conf_params[i]] = conf_params[i+1];
                console.log(`[CONFIG] default set: ${conf_params[i]} = '${conf_params[i+1]}'`);
            }
        }
        console.log(`[CONFIG] selection after defaults:`, JSON.stringify(this.selection));

        const url_params = document.location.hash ? document.location.hash.substring(1).split(':') : document.location.pathname.split('/').pop().split(':');
        console.log(`[CONFIG] url_params: ${JSON.stringify(url_params)}, length: ${url_params.length}`);

        if (url_params.length % 2 == 0) {
            this.selection = {};

            for (let i = 0; i < url_params.length; i += 2) {
                // Validate parameters from URL - do they match a selector?
                for (const key in this.selector_objects) {
                    if (this.selector_objects[key].isValidSelector(url_params[i])) {
                        this.selection[url_params[i]] = url_params[i+1];
                        console.log(`[CONFIG] URL set: ${url_params[i]} = '${url_params[i+1]}'`);
                    }
                }
            }
        }
        console.log(`[CONFIG] FINAL selection:`, JSON.stringify(this.selection));
    }

    addSelectorItem(id) {
        const title = options_translate[id] ?? id;

        const html = `
            <div id="${id}_selector" class="configurator-selector configurator-selector--disabled" data-id="${id}" data-selected="">
                <a href="#" class="head configurator-selector__head">
                    <div class="configurator-selector__title-wrap">
                        <span class="subheading">${title}</span><br />
                        <span class="label small-text">(none selected)</span>
                    </div>
                    <span class="thumbnail"></span>
                    <span class="configurator-selector__toggle">
                        <svg class="off" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 5v14M5 12h14"/></svg>
                        <svg class="on" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M5 12h14"/></svg>
                    </span>
                </a>
                <div class="configurator-selector__panel">
                    <div class="configurator-selector__items">
                    </div>
                </div>
            </div>
        `;

        document.getElementById('selectors').insertAdjacentHTML('beforeend', html);
        document.querySelector('#' + id + '_selector a.head').addEventListener('click', (e) => this.toggleSelector(e));
    }

    async refreshConfigurator(trigger) {
        /*

        // Global configurator rules
        if (selection.nightstands != undefined &&
                ['vallero', 'pinno', 'pinno282cm', 'pinno282cmtable'].includes(selection.headboards)) {
            resetSelector('nightstands');
        }

        if (init_configurators.includes('boxsprings') &&
                selection.boxsprings == null && selection.toppers != undefined && selection.toppers != null) {
            resetSelector('toppers');
        }*/

        // Refresh selectors, passing the trigger
        await this.refreshSelectors(trigger);

        this.calculatePrice();
        this.updateUrlParams();
        this.updatePlayer();
    }

    renderSelector(id, items, settings) {
        const selector = document.getElementById(id+'_selector');
        if (!selector) { return; }

        settings = { ...{'thumbnails': false, 'columns': 4, 'allow_none': true, 'minimum_count': 1}, ...settings };

        let html = '';
        let noneHtml = '';

        if (settings.allow_none) {
            noneHtml = `<a href="#" data-id="" data-label="None" class="${settings.thumbnails ? 'configurator-item--thumb' : 'opt-label'}"><div class="configurator-none-thumb"></div><div class="configurator-item__label small-text">(${ options_translate['no_selection'] ?? 'None' })</div></a>`;
        }

        let group_by = -1;
        let is_first_group = true;

        html += `<div>`;
        const keep_aspect_ratio = !items.some(item => item.thumbnail?.startsWith(bed_configuration.cylindo_base_url));
        for (const item of items) {
            if (item.group_by != group_by) {
                html += `</div>`;

                if (item.group_by != undefined) {
                    html += `<div class="subheading" style="padding:16px 0 6px">${item.group_by}</div>`;
                }
                html += `<div class="configurator-item-grid">`;
                if (is_first_group && noneHtml) {
                    html += noneHtml;
                    is_first_group = false;
                }
            }

            if (settings.thumbnails) {
                html += this.renderItemWithThumbnail(item, keep_aspect_ratio);
            } else {
                html += this.renderItemText(item);
            }

            group_by = item.group_by;
        }

        selector.querySelector('.configurator-selector__items').innerHTML = html;
        selector.querySelectorAll('.configurator-selector__items a').forEach(elm => {
            elm.addEventListener('click', (e) => this.selectorClick(e));
        });

        selector.classList.remove('configurator-selector--disabled');
        selector.hidden = items.length < settings.minimum_count;
        this.updateSelectorState(id);
    }

    renderItemWithThumbnail(item, keep_aspect_ratio = true) {
        const sold_out = configurator.enable_ecommerce == true && item.available == false;
        const sold_out_html = sold_out ? '<div class="configurator-item__soldout-overlay subheading">Sold out</div>' : '';

        return `
            <a href="#" data-id="${item.id}" data-label="${item.label}" class="configurator-item--thumb${sold_out ? ' configurator-item--soldout' : ''}">
                <img class="configurator-item__image" width="118" height="84" src="${item.thumbnail}" loading="lazy" />
                <div class="configurator-item__label small-text">${item.label}</div>
                ${sold_out_html}
            </a>
        `;
    }

    renderItemText(item) {
        const sold_out = configurator.enable_ecommerce == true && item.available == false;
        const label = sold_out ? 'Sold out' : item.label;

        return `
            <a href="#" data-id="${item.id}" data-label="${item.label}" class="opt-label${sold_out ? ' configurator-item--soldout' : ''}">${label}</a>
        `;
    }

    resetSelectorData(id) {
        delete this.selection[id];
        const sel = document.querySelector(`#selectors .configurator-selector[data-id='${id}']`);

        if (!sel) { return; }

        sel.classList.add('configurator-selector--disabled');
        sel.querySelector('.head .label').innerHTML = '(none selected)';
        sel.querySelector('.head .thumbnail').innerHTML = '';
        sel.querySelector('.configurator-selector__items').innerHTML = '';
    }

    selectorClick(e) {
        e.preventDefault();

        const button = e.currentTarget;
        const selector = button.closest('.configurator-selector');
        const type = selector.dataset.id;

        if (button.classList.contains('configurator-item--soldout')) { return; }

        selector.classList.remove('active');
        selector.querySelector('.configurator-selector__panel').style.height = '0px';

        this.selection[type] = button.dataset.id == '' ? null : button.dataset.id;

        this.updateSelectorState(type);
        this.refreshConfigurator(type);
    }

    updateSelectorState(id) {
        const selector = document.getElementById(id+'_selector');

        selector.querySelectorAll('.configurator-selector__items a').forEach(elm => {
            elm.classList.remove('configurator-item--selected');
        });

        if (this.selection[id] != null && selector.querySelector(`[data-id='${ this.selection[id] }']`) == null) {
            console.log(`[CONFIG] ${this.selection[id]} not found in DOM selector`);
            if (this.selector_objects[id] && typeof this.selector_objects[id].substituteWithValidProduct === 'function') {
                this.selector_objects[id].substituteWithValidProduct();
                this.updateUrlParams();
            } else {
                this.selection[id] = null;
            }
        }
        if (this.selection[id] == null) {
            var allow_none = true;
            if (['size', 'fabric', 'firmness', 'boxsprings-firmness', 'benchlegs'].includes(id)) { allow_none = false; }
            var firstItem = selector.querySelector('.configurator-selector__items a');
            this.selection[id] = allow_none ? null : (firstItem ? firstItem.dataset.id : null);
        }
        if (this.selection[id]) {
            const item = selector.querySelector(`[data-id='${this.selection[id]}']`);
            if (item) {
                item.classList.add('configurator-item--selected');
                selector.querySelector('.head .label').innerHTML = item.dataset.label;
                if (item.querySelector('img')) {
                    const thumb_url = item.querySelector('img').getAttribute('src');
                    selector.querySelector('.head .thumbnail').innerHTML = `<img class="configurator-selector__thumb" src="${thumb_url}" width="600" height="300" loading="lazy" />`;
                }
            }
        } else {
            const none = selector.querySelector(`[data-label='None']`);
            if (none) { none.classList.add('configurator-item--selected'); }
            selector.querySelector('.head .thumbnail').innerHTML = '';
            selector.querySelector('.head .label').innerHTML = '(none selected)';
        }
    }

    toggleSelector(e) {
        e.preventDefault();
        e.stopPropagation();

        const active_selector = e.currentTarget.parentElement;

        if (active_selector.classList.contains('configurator-selector--disabled')) { return; }

        if (active_selector.classList.contains('active')) {
            this.closeSelector(active_selector);
        } else {
            this.openSelector(active_selector);
        }
    }

    openSelector(sel) {
        sel.classList.add('active');
        sel.querySelector('.configurator-selector__panel').style.height = (sel.querySelector('.configurator-selector__items').offsetHeight + 15) + 'px';
    }

    closeSelector(sel) {
        sel.classList.remove('active');
        sel.querySelector('.configurator-selector__panel').style.height = '0px';
    }

    resetSelector(id) {
        const sel = document.querySelector(`#selectors .configurator-selector[data-id='${id}']`);
        if (sel) { this.closeSelector(sel); }

        delete(this.selection[id]);
        this.updateSelectorState(id);
    }


    applyReferenceProduct(product) {        
        if (product.category && product.category in configurator.reference) {
            const ref = configurator.reference[product.category];
            product.original_title = product.title;
            product.original_id = product.productid;

            product.title = ref.title;
            product.productid = ref.productid;
            product.cylindo_model = ref.cylindo_model;
            if (!product.image) { product.image = ref.image; }
            return true;
        }
        return false;
    }


    variantToItem(product, variant) {
        return {
            'id': product.productid,
            'handle': product.productid,
            'label': product.title,
            'ids': [variant.id.replace('gid://shopify/ProductVariant/', '')],
            'skus': [variant.sku],
            'price': variant.price,
            'thumbnail': variant.featured_image ? variant.featured_image.src : (product.images.length > 0 ? product.images[0].src: null),
            'available': variant.availableForSale,
        };
    }

    productToItem(product) {
        return {
            'id': product.productid,
            'handle': product.productid,
            'label': product.title,
            'ids': [product.variants[0].id.replace('gid://shopify/ProductVariant/', '')],
            'skus': [product.variants[0].sku],
            'price': product.variants[0].price,
            'thumbnail': product.image,
            'available': product.variants[0].availableForSale,
        };
    }

    async graphQL(query) {
        let data = null;
        //console.log(query);
        try {
            const response = await(await fetch(storefront_domain+'/api/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/graphql',
                    'X-Shopify-Storefront-Access-Token': storefront_access_token
                },
                'body': query
            })).json();

            if ("errors" in response) {
                for (const error of response.errors) {
                    console.log("GraphQl Query Error: " + error.message);
                }
            }

            data = response.data;
        } catch (err) {
            console.log('GraphQL call failed', err);
        }

        return data;
    }

	async loadProductData(collection, filters, metafields, use_images) {
        let filter_arr = [];
        for (const filter of filters) {
            filter_arr.push(`
            {
                productMetafield:{
                  namespace: "configurator", key: "${filter.key}", value: "${filter.value}"
                }
            }`);
        }
        const filter_str = filter_arr.length > 0 ? `, filters: [${filter_arr.join(',')}]` : ``;

        metafields = ['productid', 'category', 'cylindo_model', ...metafields]; //'size', 'fabric'
        let field_str = '';
        for (const field of metafields) {
            const f = field.includes('.') ? field.split('.') : ['configurator', field];
        	field_str += `	${f[1]}: metafield(namespace: "${f[0]}", key: "${f[1]}") { value }\n`;
        }

        const data = await this.graphQL(`
            query sectionProducts {
                collection(handle: "${collection}") {
                  handle
                  products(first: 250 ${filter_str}) {
                        edges {
                            node {
                                handle
                                title
                                featuredImage { url }
                                ${ use_images ? 'images(first: 5) { edges { node { id url } } }' : '' }
                                ${ field_str }
                                variants(first: 250) {
                                    edges {
                                        node {
                                            id
                                            sku
                                            price { amount currencyCode }
                                            compareAtPrice { amount currencyCode }
                                            title
                                            ${ use_images ? 'image { url }' : '' }
                                            selectedOptions { name value }
                                            availableForSale
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `);

        const products = [];
        if (data && data.collection && data.collection.products && data.collection.products.edges) {
            const result = data.collection.products.edges;

            for (const item of result) {
                const p = {
                    handle: item.node.handle,
                    title: item.node.title,
                    image: item.node.featuredImage ? item.node.featuredImage.url : '',
                    variants: [],
                    images: []
                };
                for (const field of metafields) {
                    const f = field.split('.').pop();
                	p[f] = item.node[f] ? item.node[f].value : null;
                }
                if (p.cylindo_model && p.cylindo_model != '') {
                    // Remove presets from Cylindo model value
                    const arr = p.cylindo_model.split(':');
                    p.cylindo_model = arr.shift();
                }

                for (const v of item.node.variants.edges) {
                    p.variants.push({
                        id: v.node.id,
                        sku: v.node.sku,
                        price: v.node.price ? parseFloat(v.node.price.amount) : 0,
                        currency: v.node.price ? v.node.price.currencyCode : '',
                        title: v.node.title,
                        'option1': v.node.selectedOptions[0].value,
                        'option2': v.node.selectedOptions.length > 1 ? v.node.selectedOptions[1].value : null,
                        [v.node.selectedOptions[0].name]: v.node.selectedOptions[0].value,
                        image: v.node.image ? v.node.image.url : null,
                        availableForSale: v.node.availableForSale,
                    });
                }

                if (use_images) {
                    for (const v of item.node.images.edges) {
                        p.images.push({
                            id: v.node.id,
                            src: v.node.url,
                        });
                    }
                }

                products.push(p);
            }
        } else {
            console.warn(`Collection "${collection}" not found or returned no products`);
        }

        return products;
    }

	async loadProductVariantData(product_id, metafields, use_images) {
        metafields = ['productid', 'category', 'cylindo_model', ...metafields]; //'size', 'fabric'
        let field_str = '';
        for (const field of metafields) {
            const f = field.includes('.') ? field.split('.') : ['configurator', field];
        	field_str += `	${f[1]}: metafield(namespace: "${f[0]}", key: "${f[1]}") { value }\n`;
        }

        const data = await this.graphQL(`
            query getProductById {
                product(id: "${product_id}") {
                    handle
                    title
                    featuredImage { url }
                    ${ use_images ? 'images(first: 5) { edges { node { id url } } }' : '' }
                    ${ field_str }
                    variants(first: 250) {
                        edges {
                            node {
                                id
                                sku
                                price { amount currencyCode }
                                compareAtPrice { amount currencyCode }
                                title
                                ${ use_images ? 'image { url }' : '' }
                                selectedOptions { name value }
                                availableForSale
                            }
                        }
                    }
                }
            }
        `);

        const p = {};

        if (data && data.product) {
            p.handle = data.product.handle;
            p.title = data.product.title;
            p.image = data.product.featuredImage ? data.product.featuredImage.url  : '';
            p.variants = [];
            p.images = [];

            for (const field of metafields) {
                const f = field.split('.').pop();
                p[f] = data.product[f] ? data.product[f].value : null;
            }

            for (const v of data.product.variants.edges) {
                const vitem = {
                    id: v.node.id,
                    sku: v.node.sku,
                    price: v.node.price ? parseFloat(v.node.price.amount) : 0,
                    currency: v.node.price ? v.node.price.currencyCode : '',
                    title: v.node.title,
                    image: v.node.image ? v.node.image.url : null,
                    availableForSale: v.node.availableForSale,
                };
                vitem[v.node.selectedOptions[0].name.toLowerCase()] = v.node.selectedOptions[0].value;
                if (v.node.selectedOptions.length > 1) { vitem[v.node.selectedOptions[1].name.toLowerCase()] = v.node.selectedOptions[1].value; }

                p.variants.push(vitem);
            }

            if (use_images) {
                for (const v of data.product.images.edges) {
                    p.images.push({
                        id: v.node.id,
                        src: v.node.url,
                    });
                }
            }
        }

        return p;
    }

    getThumbnail() {
        const base_url = bed_configuration.cylindo_base_url + this.cylindo_specs.code + "/frames/3/thumb.jpg";
        const params = [];

        for (const feat in this.cylindo_specs.features) {
            if (this.cylindo_specs.features[feat]) {
               params.push(encodeURIComponent(feat) + ":" + encodeURIComponent(this.cylindo_specs.features[feat]));
            }
        }

        return base_url + (params.length > 0 ? ("?feature=" + params.join('&feature=')) : "");
    }

    getSwatch(value, feature, crop) {
        const default_feature = 'UPHOLSTERY';
        const default_crop = '100,100,236,168';

        // Detect if this is a Holme nightstand product
        // NOTE: This is a workaround until Cylindo implements a better solution since we cannot call the swatch endpoint with two features (both bedside table set to upholstered and Upholstery)
        const isHolmeNightstand = bed_configuration.category === "holmefabric" ||
                                 (bed_configuration.cylindo_model &&
                                  typeof bed_configuration.cylindo_model === 'string' &&
                                  bed_configuration.cylindo_model.toLowerCase().includes('holme'));

        // Use default feature (UPHOLSTERY) for all products, including Holme
        // since we're using VINDO model for Holme which uses UPHOLSTERY
        const featureToUse = feature != null ? feature : default_feature;

        // For Holme nightstand, hard-code the model to "VINDO_180X210_OPEN"
        const model = isHolmeNightstand ?
            "VINDO_180X210_OPEN" :
            (typeof bed_configuration.cylindo_model == "object" ? bed_configuration.cylindo_model['180'] : bed_configuration.cylindo_model);

        const cylindo_thumbnail_url = bed_configuration.cylindo_base_url + model + '/material/swatch.jpg?&feature=#feature#&crop=(#crop#)';

        const thumbnail = cylindo_thumbnail_url
            .replace('#feature#', featureToUse + ':' + value)
            .replace('#crop#', crop != null ? crop : default_crop);

        return thumbnail;
    }

    getConfigUrl(absolute) {
        let path_arr = document.location.pathname.split('/');
        // Custom by IMPACT: strip every trailing config segment, not just one - a config
        // value containing a '/' would otherwise leave stale segments behind and the URL
        // would grow by one segment on every selection change.
        while (path_arr.length > 0 && (path_arr[path_arr.length -1].includes(':') || path_arr[path_arr.length -1] == '')) {
            path_arr.pop();
        }

        // Normalize /collections/X/products/Y to /products/Y
        const productsIdx = path_arr.indexOf('products');
        if (productsIdx > 1) {
            path_arr = ['', 'products', ...path_arr.slice(productsIdx + 1)];
        }

        const params = [];
        for (const sel in this.selection) {
            if (this.selection[sel] != null) {
               // Custom by IMPACT: a '/' in a key or value would turn the config into extra
               // path segments, so keep it out of the URL.
               params.push((sel + ':' + this.selection[sel]).replace(/\//g, ''));
            }
        }

        const base_url = (absolute ? document.location.protocol + '//' + document.location.hostname + (document.location.port ? ":" + document.location.port : "") : '') + path_arr.join('/') + '/';

        return base_url + params.join(':');
    }

    setupListeners() {
        const cart_div = document.querySelector('.add-to-cart-container');

        if (cart_div != null) {
            const addToCartBtn = cart_div.querySelector('.add-to-cart');
            if (addToCartBtn) {
                addToCartBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.addToCart(e.currentTarget);
                });
            }

            const urlParams = new URLSearchParams(document.location.search);
            this.bundle_id = null;

            if (urlParams.has('edit')) {
                const editValue = urlParams.get('edit');
                if (editValue && editValue.trim() !== '') {
                    if (addToCartBtn && addToCartBtn.dataset.updateLabel) {
                        addToCartBtn.innerHTML = addToCartBtn.dataset.updateLabel;
                    }
                    this.bundle_id = editValue;
                }
            }
        }

        if (this.viewer) {
            this.viewer.addEventListener("error", event => {
                const err = document.querySelector(".configurator-cylindo-error");
                if (event.detail.error != null) {
                    err.classList.remove("hidden");
                    err.querySelector("a").title = event.detail.error;
                } else {
                    err.classList.add("hidden");
                }
            });
        }

        if (document.querySelector('#share_link')) {
            const shareModal = document.getElementById('configurator-share');

            document.querySelector('#share_link').addEventListener('click', (e) => {
                e.preventDefault();
                this.shareConfiguration();
            });

            if (shareModal) {
                const shareCopyBtn = shareModal.querySelector('.configurator-share__copy-btn');
                if (shareCopyBtn) {
                    shareCopyBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        const input_fld = shareModal.querySelector('input[name="share_link"]');
                        if (input_fld && input_fld.value) {
                            this.copyToClipboard(input_fld.value);
                            const original = shareCopyBtn.innerHTML;
                            shareCopyBtn.textContent = '✓';
                            setTimeout(() => { shareCopyBtn.innerHTML = original; }, 1500);
                        }
                    });
                }
            }
        }

        for (const selector in this.selector_objects) {
            this.selector_objects[selector].setupListeners();
        }

        const skuDetails = document.querySelector('.configurator-meta__sku-details');
        if (skuDetails) {
            const skuToggle = skuDetails.querySelector('[data-sku-toggle]');
            const skuPanel = skuDetails.querySelector('.configurator-meta__sku-panel');
            if (skuToggle && skuPanel) {
                skuToggle.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (skuDetails.classList.contains('is-open')) {
                        skuPanel.style.height = skuPanel.scrollHeight + 'px';
                        requestAnimationFrame(() => { skuPanel.style.height = '0px'; });
                        skuDetails.classList.remove('is-open');
                    } else {
                        skuPanel.style.height = skuPanel.scrollHeight + 'px';
                        skuPanel.addEventListener('transitionend', () => { skuPanel.style.height = 'auto'; }, { once: true });
                        skuDetails.classList.add('is-open');
                    }
                });
            }
            const copyBtn = skuDetails.querySelector('[data-sku-copy]');
            if (copyBtn) {
                const copyLabel = copyBtn.textContent.trim();
                const copySvg = copyBtn.querySelector('svg')?.outerHTML || '';
                copyBtn.addEventListener('click', () => {
                    const skuEls = skuDetails.querySelectorAll('.sku span');
                    const skuText = Array.from(skuEls).map(el => el.textContent.trim()).filter(Boolean).join('\n');
                    this.copyToClipboard(skuText);
                    copyBtn.innerHTML = copySvg + ' ✓';
                    setTimeout(() => { copyBtn.innerHTML = copySvg + ' ' + copyLabel; }, 1500);
                });
            }
        }
    }

    copyToClipboard(text) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(text).catch(() => this.copyFallback(text));
        } else {
            this.copyFallback(text);
        }
    }

    copyFallback(text) {
        const ta = document.createElement('textarea');
        ta.value = text;
        ta.style.cssText = 'position:fixed;opacity:0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
    }

    shareConfiguration() {
        const shareModal = document.getElementById('configurator-share');
        if (!shareModal) return;

        const input_fld = shareModal.querySelector('input[name="share_link"]');
        if (input_fld) {
            input_fld.value = this.getConfigUrl(true);
        }
        shareModal.show();
    }

    async addToCart(submitBtn) {
        submitBtn.disabled = true;

        // Generate config URL
        const config_url = this.getConfigUrl();
        const thumb_url = this.getThumbnail();

        var cart = await(await fetch(window.Shopify.routes.root + 'cart.js')).json();

        // Check for items to remove from cart when updating an existing configuration
        if (this.bundle_id) {
            // Use updates object for removing multiple items at once
            let updates = {};

            // Collect all items to remove
            for (const cart_item of cart.items) {
                if (cart_item.properties && cart_item.properties._configId
                        && cart_item.properties._configId == this.bundle_id) {

                    // Add to updates object with quantity 0
                    updates[cart_item.key] = 0;
                }
            }

            // Remove all matching items at once if any were found
            if (Object.keys(updates).length > 0) {
                await fetch(window.Shopify.routes.root + 'cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates: updates })
                });

                // Fetch cart again after removal to get updated state
                cart = await(await fetch(window.Shopify.routes.root + 'cart.js')).json();
            }
        }

        // Generate bundle ID - use existing if updating, create new if adding
        const bundleId = this.bundle_id ?? new Date().getTime();

        const formData = {'items': []};
        const sku_and_quantity = {};
        for (const sku of this.cart) {
            if (!(sku in sku_and_quantity)) {
                sku_and_quantity[sku] = 0;
            }
            sku_and_quantity[sku] += 1;
        }

        if (this.cart.length > 1) {
            // Bundle product
            for (const sku in sku_and_quantity) {
                formData.items.push({
                    'id': sku,
                    'quantity': sku_and_quantity[sku],
                    'properties': {
                        "_productTitle": page_product_title,
                        "_productId": this.cart.length > 1 ? page_variant_id : sku, // Use page main product as grouping or specific variant if not a bundle
                        "_configId": bundleId,
                        "_configUrl": config_url,
                        "_thumbUrl": thumb_url,
                    }
                });
            }
        } else {
            // Non-bundle product - use the user-selected quantity from the quantity input field
            let userQuantity = 1;  // Default to 1
            const quantityInput = document.querySelector('.quantity input');

            if (quantityInput) {
                const inputValue = parseInt(quantityInput.value);
                userQuantity = (!isNaN(inputValue) && inputValue > 0) ? inputValue : 1;
            }

            // Override with the user quantity
            for (const sku in sku_and_quantity) {
                formData.items.push({
                    'id': sku,
                    'quantity': userQuantity,
                    // Always include properties to ensure configuration can be edited later
                    'properties': {
                        "_productTitle": page_product_title,
                        "_productId": sku,
                        "_configId": bundleId,
                        "_configUrl": config_url,
                        "_thumbUrl": thumb_url,
                    }
                });
            }
        }

        await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        });

        submitBtn.disabled = false;
        await this.refreshCart();

        const cartDrawer = document.querySelector('.js-cart-drawer');
        if (cartDrawer) cartDrawer.open(submitBtn);
    }

    async refreshCart() {
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart.js');
            if (!response.ok) throw new Error('Network response was not ok');
            const cart = await response.json();

            document.dispatchEvent(new CustomEvent('on:cart:add'));
            document.dispatchEvent(new CustomEvent('on:cart:change', { detail: { cart: cart } }));

            document.querySelectorAll('[data-cart-count], .cart-quantity, .js-cart-count').forEach(el => {
                el.textContent = cart.item_count;
                el.hidden = cart.item_count === 0;
                el.classList.toggle('hidden', cart.item_count === 0);
            });
        } catch (error) {
            console.error('Error refreshing cart:', error);
        }
    }


    calculatePrice() {
        let totalPrice = 0;
        const skus = [];
        let ids = [];

        const priceData = { total: 0, 'skus': [], 'ids': [] };

        for (const key in this.selector_objects) {
            this.selector_objects[key].getPriceData(priceData);
        }

        let sold_out = false;
        if (Object.keys(this.selector_objects).length == 1) {
            if (Object.values(this.selector_objects)[0].isSoldOut()) {
                sold_out = true;
            }
        }

        if (priceData.ids.length > 0) {
            this.cart.length = 0;
            this.cart.push(...priceData.ids);
        }

        if (document.querySelector('.sku')) {
            const skuList = priceData.skus.filter(s => s);
            document.querySelector('.sku').innerHTML = skuList.map(s => '<span>' + s + '</span>').join('');
            const skuCount = document.querySelector('.sku-count');
            if (skuCount) {
                skuCount.textContent = skuList.length + ' ' + (options_translate['items'] ?? 'items');
            }
            const skuDetails = document.querySelector('.configurator-meta__sku-details');
            if (skuDetails) skuDetails.hidden = skuList.length === 0;
        }

        const addToCartBtn = document.querySelector('.add-to-cart');

        if (document.querySelector('.add-to-cart-container') != null) {
            addToCartBtn.innerHTML = this.bundle_id ? addToCartBtn.dataset.updateLabel : addToCartBtn.dataset.addLabel;

            const priceWrap = document.querySelector('.add-to-cart-container .price');
            const priceEl = document.querySelector('[data-configurator-price]');

            if (configurator.enable_ecommerce == true && sold_out == true) {
                if (priceData.total > 0 && priceEl) {
                    priceEl.innerHTML = Shopify.formatMoney(parseFloat(priceData.total)*100) + ' ' + bed_configuration.currency;
                    if (priceWrap) priceWrap.hidden = false;
                }
                addToCartBtn.disabled = true;
                addToCartBtn.innerHTML = addToCartBtn.dataset.soldoutLabel;
            } else if (priceData.total > 0 && this.cart.length > 0) {
                if (priceEl) {
                    priceEl.innerHTML = Shopify.formatMoney(parseFloat(priceData.total)*100) + ' ' + bed_configuration.currency;
                }
                if (priceWrap) priceWrap.hidden = false;
                addToCartBtn.disabled = false;
            } else {
                if (priceWrap) priceWrap.hidden = true;
                addToCartBtn.disabled = true;
            }
        }
    }

    updateUrlParams() {
        const config_url = this.getConfigUrl(true);
        window.history.pushState({}, "", config_url + document.location.search);
    }

    updatePlayer() {
        // Ask all selctors for Cylindo specs
        this.cylindo_specs = {'code': bed_configuration.cylindo_model, 'features': {}};

        for (const key in this.selector_objects) {
            this.selector_objects[key].getCylindoSpecs(this.cylindo_specs);
        }

        // Update Cylindo Viewer
        if (this.cylindo_specs.code != this.viewer.getAttribute("code")) {
            this.viewer.setAttribute("code", this.cylindo_specs.code);
        }
        this.viewer.features = this.cylindo_specs.features;

        this.viewer.classList.remove('hidden');

        if (document.querySelector('.debug')) { document.querySelector('.debug .features').innerHTML = JSON.stringify(this.viewer.features); }
    }

    buildFirmnessCrossCombinations(firmnesses) {
        const mattress_combos = [
            ['Soft'],
            ['Medium'],
            ['Firm'],
            ['XFirm'],

            ['Soft', 'Medium'],
            ['Soft', 'Firm'],
            ['Soft', 'XFirm'],

            ['Medium', 'Firm'],
            ['Medium', 'XFirm'],

            ['Firm', 'XFirm'],
        ];

        const crossed = {};

        mattress_combos.map((combo) => {
            const A = combo[0].toLowerCase();
            const B = (combo.length > 1 ? combo[1] : combo[0]).toLowerCase();
            if (A in firmnesses && B in firmnesses) {
                if ((firmnesses[A].price > 0 && firmnesses[B].price > 0) || configurator.enable_ecommerce == false) {
                    const new_item = {
                        'title': combo.join(", "),
                        'skus': [...firmnesses[A].skus, ...firmnesses[B].skus],
                        'ids': [...firmnesses[A].ids, ...firmnesses[B].ids],
                        'price': firmnesses[A].price+firmnesses[B].price,
                        'available': firmnesses[A].available && firmnesses[B].available,
                    }
                    const firm_key = combo.join("-").toLowerCase(); //new_item['title'].replace(/\s/g, '').replace(/,/g, '-');
                    crossed[firm_key] = new_item;
                }
            }
        });

        return crossed;
    }
    m3_colors = {
        'Black': 'CLASSIC_BLACK',
        'Walnut Door':'HOLMEDOOR IN WALNUT',
        'Walnut High':'HOLMEDOORHIGH IN WALNUT',
        'Walnut':'HOLMECLASSIC IN WALNUT',
        'Chrome': 'CHROME',
        'Brass':'BRASS'
    }
    m3_fabrics = {
        '0CLLG': ['CLIFF_LIGHT_GREY', 'Light Grey', 'Cliff', 1],
        '0ROJD': ['DG_JACKIE_DALMATIAN', 'Jackie Dalmation', 'Limited Edition', 0],

        '0LBL': ['LUXURY_BLACK', 'Luxury Black', 'Luxury', 1],
        '0LDG': ['LUXURY_DARK_GREY', 'Luxury Dark Grey', 'Luxury', 1],
        '0LLG': ['LUXURY_LIGHT_GREY', 'Luxury Light Grey', 'Luxury', 1, true], // Default
        '0LSA': ['LUXURY_SAND', 'Luxury Sand', 'Luxury', 1],

        '0WBE': ['BEIGE_WOOL', 'Wool Beige', 'Wool', 1],
        '0WBL': ['BLACK_WOOL', 'Wool Black', 'Wool', 1],
        '0WDG': ['DARK_GREY_WOOL', 'Wool Dark Grey', 'Wool', 1],
        '0WLG': ['LIGHT_GREY_WOOL', 'Wool Light Grey', 'Wool', 1],

        '0DEG': ['DG_ZARAGOZA_EGGSHELL', 'DG Zaragoza Eggshell', 'Designers Guild - Zaragoza', 1],
        //'0DES': ['DG_ZARAGOZA_GOLD', 'DG Zaragoza Gold', 'Designers Guild - Zaragoza', 1],
        '0DPE': ['DG_ZARAGOZA_PEBBLE', 'DG Zaragoza Pebble', 'Designers Guild - Zaragoza', 1],
        '0DST': ['DG_ZARAGOZA_STEEL', 'DG Zaragoza Steel', 'Designers Guild - Zaragoza', 1],

        '0DRGR': ['DG_ROTHESAY_GRAPHITE', 'DG Rothesay Graphite', 'Designers Guild - Rothesay', 1],
        '0DRPU': ['DG_ROTHESAY_PUMICE', 'DG Rothesay Pumice', 'Designers Guild - Rothesay', 1],
        '0DRZI': ['DG_ROTHESAY_ZINK', 'DG Rothesay Zinc', 'Designers Guild - Rothesay', 1],
        '0DRST': ['DG_ROTHESAY_STONE', 'DG Rothesay Stone', 'Designers Guild - Rothesay', 1],

        '0E02': ['DG_GLENVILLE_CELADON', 'DG Glenville Celadon', 'Designers Guild - Glenville', 1],
        '0E01': ['DG_GLENVILLE_GRANITE', 'DG Glenville Granite', 'Designers Guild - Glenville', 1],
        '0E03': ['DG_GLENVILLE_OYSTER', 'DG Glenville Oyster', 'Designers Guild - Glenville', 1],
        '0E00': ['DG_GLENVILLE_ZINC', 'DG Glenville Zinc', 'Designers Guild - Glenville', 1],

        '0E05': ['LUXURY_LIGHT_GREY', 'DG Bilbao Celadon', 'Designers Guild - Bilbao', 0],
        '0E06': ['LUXURY_LIGHT_GREY', 'DG Bilbao Gunmetal', 'Designers Guild - Bilbao', 0],
        '0E04': ['LUXURY_LIGHT_GREY', 'DG Bilbao Noir', 'Designers Guild - Bilbao', 0],
        '0E07': ['LUXURY_LIGHT_GREY', 'DG Bilbao Silver', 'Designers Guild - Bilbao', 0],

        '0E08': ['LUXURY_LIGHT_GREY', 'DG Tammaro Dove', 'Designers Guild - Tammaro', 0],
        '0E09': ['LUXURY_LIGHT_GREY', 'DG Tammaro Smoke', 'Designers Guild - Tammaro', 0],

        '0E16': ['RO_ASURI_CASHEW', 'RO Asuri Cashew', 'The Romo Group - Asuri', 1],
        '0E18': ['RO_ASURI_MULBERRY', 'RO Asuri Mulberry', 'The Romo Group - Asuri', 1],
        '0E19': ['RO_ASURI_ROSE', 'RO Asuri Rose Quartz', 'The Romo Group - Asuri', 1],
        '0E20': ['RO_ASURI_ANTLER', 'RO Asuri Antler', 'The Romo Group - Asuri', 1],
        '0E21': ['RO_ASURI_PIGEON', 'RO Asuri Pigeon', 'The Romo Group - Asuri', 1],

        '0E13': ['LUXURY_LIGHT_GREY', 'RO Kendari Pigeon', 'The Romo Group - Kendari', 0],
        '0E12': ['LUXURY_LIGHT_GREY', 'RO Kendari Seal', 'The Romo Group - Kendari', 0],

        '0E15': ['LUXURY_LIGHT_GREY', 'RO Dakota Suede II Rope', 'The Romo Group - Dakota Suede II', 0],
        '0E14': ['LUXURY_LIGHT_GREY', 'RO Dakota Suede II Shell', 'The Romo Group - Dakota Suede II', 0],

        '0E22': ['DG_AZUARA_ECRU', 'DG Azuara Ecru', 'Designers Guild - Azuara', 1],
        '0E23': ['DG_AZUARA_NATURAL', 'DG Azuara Natural', 'Designers Guild - Azuara', 1],

        '0E24': ['RO_LOOP_OYSTER', 'RO Loop Oyster', 'The Romo Group - Loop', 1],
        '0E25': ['RO_LOOP_STONE', 'RO Loop Stone', 'The Romo Group - Loop', 1],
        '0E26': ['RO_LOOP_EVERGREEN', 'RO Loop Evergreen', 'The Romo Group - Loop', 1],
        '0E27': ['RO_LOOP_MARINE', 'RO Loop Marine', 'The Romo Group - Loop', 1],

        '0E28': ['DG_NOTTHING_HILL_SLATE', 'DG Derwen Notting Hill', 'Designers Guild - Derwen', 1],
        '0E29': ['DG_DERWEN_JAPANESE_INK', 'DG Derwen Japanese', 'Designers Guild - Derwen', 1],
        '0E30': ['DG_DERWEN_RETRO_OLIVE', 'DG Derwen Retro Olive', 'Designers Guild - Derwen', 1],

        '0E31': ['KV_MELANGE_NAP211', 'KV Melange Nap Beige', 'Kvadrat - Melange Nap', 1],
        '0E32': ['KV_MELANGE_NAP111', 'KV Melange Nap Light Grey', 'Kvadrat - Melange Nap', 1],
        '0E33': ['KV_MELANGE_NAP191', 'KV Melange Nap Dark Grey', 'Kvadrat - Melange Nap', 1],

        '0E34': ['KV_FIORD2_322', 'KV Fiord2 Beige', 'Kvadrat - Fiord2', 1],
        '0E35': ['KV_FIORD2_262', 'KV Fiord2 Light Brown', 'Kvadrat - Fiord2', 1],
        '0E36': ['KV_FIORD2_171', 'KV Fiord2 Dark Grey', 'Kvadrat - Fiord2', 1],

        '0E37': ['DG_SKYE_CHALK', 'DG Skye Chalk', 'Designers Guild - Skye', 1],
        '0E38': ['DG_SKYE_ZINC', 'DG Skye Zinc', 'Designers Guild - Skye', 1],
        '0E39': ['DG_SKYE_AQUA', 'DG Skye Aqua', 'Designers Guild - Skye', 1],
        '0E40': ['DG_SKYE_MIDNIGHT', 'DG Skye Midnight', 'Designers Guild - Skye', 1],

        '0WALN': ['WALNUT', 'Walnut', 'Walnut', 0],
    };
    pinnoOtteroNavigator = {
        'pinno': {
            '158': {
                'up' : '186',
                'down' : null,
            },
            '186': {
                'up' : '282',
                'down' : '158',
            },
            '218': {
                'up' : '282',
                'down' : '186',
            },
            '282': {
                'up' : null,
                'down' : '186',
            }
        },
        'ottero': {
            '156': {
                'up' : '186',
                'down' : null,
            },
            '186': {
                'up' : '216',
                'down' : '156',
            },
            '216': {
                'up' : null,
                'down' : '186',
            },
            '252': {
                'up' : '282',
                'down' : null,
            },
            '282': {
                'up' : '312',
                'down' : '252',
            },
            '312': {
                'up' : null,
                'down' : '282',
            }
        }
    };
}

const configurator = new Configurator();
